import { useEffect } from "react"
import { defineEnviroment, getFullUrl } from "../lib/Utils";
import { postSanityData } from "../lib/fetchServiceApi";
// import Pusher from 'pusher-js';
import { VERSION } from '../../version';

const APP_KEY = 'f4bf6ce12cabf3d1e12c';
const APP_CLUSTER = 'mt1';

export default function GlobalHook({ children }) {
  const RELOAD_EVENT = 'reload-version';
  const WORK_AS_PRODUCTION = false; // MUST BE FALSE, for testing purposes only
  
  useEffect(()=>{
    // Password Protection
    const devBranch = 'el-librero-dev.ellibrero.com';
    const passwordProtectPage = '/password-protect';
     
    if(
      location.href.indexOf(devBranch) > 0 && 
      localStorage.getItem('password_protect') !== 'true'
      && location.pathname !== passwordProtectPage
    ){
      location.href = passwordProtectPage;
    }


    localStorage.setItem('start_session', new Date().getTime());
    

    // Traking error
    window.addEventListener('error', (e) => {
      let messageError = {
        func:'saveLogError',
        link: getFullUrl(),
        message: e?.message,
      };

      const goToError = ()=>{
        if(location.href.indexOf('/error') < 0){
          location.href = '/error';
        }
      }
      
      if(defineEnviroment() === 'PRODUCTION' || WORK_AS_PRODUCTION){
        let isErrorPage = (root.querySelectorAll('*').length < 50) ? true : false;


        if(isErrorPage){
          // document.getElementById('root').style.display = 'none';
          // setTimeout(()=>{location.reload(true);}, 5000);
        }

        setTimeout(()=>{
          const searchText = "Something's wrong";
          const foundText = Array.from(root.querySelectorAll('*')).find(element => 
            element.textContent.includes(searchText)
          );
          // test........
          if (foundText) {
            // document.getElementById('root').style.display = 'none';
            postSanityData('/api/sanity/admin-front', messageError)
              .then(()=>{
                goToError();
            })
            goToError();
          }
        }, 300);
      }
    }, true);

    // Pusher notifications
    const loadExternalJS = (url)=>{
        let script = document.createElement('script');
        script.src = url;
        script.type = 'text/javascript';
        script.async = true;
        script.onload = ()=> {
          // General socket
          const pusher = new Pusher(APP_KEY, {
            cluster: APP_CLUSTER,
          });

          let channel = pusher.subscribe('global');
          channel.bind(RELOAD_EVENT, (data) => {
            if(VERSION < data.VERSION){
              window.location.reload(true);
            }
          });
        };
        script.onerror = ()=>{
        };
        document.head.appendChild(script);
    }
    loadExternalJS('https://js.pusher.com/8.2.0/pusher.min.js');

    // Pusher notifications
    const loadExternalJsSimple = (url, onload)=>{
        let script = document.createElement('script');
        script.src = url;
        script.type = 'text/javascript';
        script.async = true;
        script.onload = ()=> {
          onload();
        };
        script.onerror = ()=>{
        };
        document.head.appendChild(script);
    }  

    // loadExternalJsSimple(
    //   'https://flow-energy-2837.my.site.com/ESWLarousse1721089358785/assets/js/bootstrap.min.js',
    //   ()=>{
    //       try {
    //         embeddedservice_bootstrap.settings.language = 'es_MX'; // For example, enter 'en' or 'en-US'
    //         embeddedservice_bootstrap.init(
    //             '00DKb000000Olug',
    //             'Larousse',
    //             'https://flow-energy-2837.my.site.com/ESWLarousse1721089358785',
    //             {
    //                 scrt2URL: 'https://flow-energy-2837.my.salesforce-scrt.com'
    //             }
    //         );
    //       } catch (err) {
    //           console.error('Error loading Embedded Messaging: ', err);
    //       }
    //   }
    // );




    // Chat     
    // loadExternalJsSimple(
    //   'https://flow-energy-2837.my.site.com/ESWLarousse1721089358785/assets/js/bootstrap.min.js',
    //   ()=>{
    //       try {
    //         embeddedservice_bootstrap.settings.language = 'es_MX'; // For example, enter 'en' or 'en-US'
    //         embeddedservice_bootstrap.init(
    //             '00DKb000000Olug',
    //             'Larousse',
    //             'https://flow-energy-2837.my.site.com/ESWLarousse1721089358785',
    //             {
    //                 scrt2URL: 'https://flow-energy-2837.my.salesforce-scrt.com'
    //             }
    //         );
    //       } catch (err) {
    //           console.error('Error loading Embedded Messaging: ', err);
    //       }
    //   }
    // );
    
    //Salesforce
    // loadExternalJsSimple(
    //   'https://cdn.evgnet.com/beacon/h55685555563p3n3wd53n3n3u091551119/el_librero_prod/scripts/evergage.min.js',
    //   ()=>{
    //       try {
    //         Evergage.init({
    //             account: '546006664',
    //             dataset: 'Engage'
    //         });
    //       } catch (err) {
    //           console.error('Error loading saleforce tag', err);
    //       }
    //   }
    // );

    // Force reload web site in old session
    setInterval(()=>{
        let timePassed = new Date().getTime() - parseInt(localStorage.getItem('start_session'));

        if(timePassed > (60 * 1000 * 60 * 6)){
          localStorage.setItem('start_session', '');
          window.location.reload();
        }
    }, 1000);

    // Sales force
    loadExternalJsSimple(
      'https://cdn.evgnet.com/beacon/h55685555563p3n3wd53n3n3u091551119/el_librero_prod/scripts/evergage.min.js',
      ()=>{

        Evergage.init({
          cookieDomain: "www.ellibrero.com",
        }).then(()=>{
          console.log('Evergage loaded V1.1.3.2');
        })
      }
    );

    document.addEventListener('click', (event) => {
      const target = event.target;

      if (target.tagName === "A" && (target).href === "https://ellibrero.com/#login") {
        event.preventDefault();
        const loginButton = document.querySelector("#loggin-user");
        if (loginButton) {
          loginButton.click();
        }
      }
    });

  }, [])
  return (<></>)
}